import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  SvgIcon,
  Typography,
  Container,
  Stack,
} from "@mui/material";
import HomeTable from "@/components/Table/Home";
import { HomePageProps } from "@/@types/HomePage";
import { IVWPost } from "@/interfaces";
import { autorun } from "mobx";
import { ReactComponent as HeroSectionPic } from "@/assets/images/Home/Hero_Section.svg";

const HomePage = (props: HomePageProps) => {
  const [postsBuy, setPostsBuy] = useState<IVWPost[]>([]);
  const [postsSell, setPostsSell] = useState<IVWPost[]>([]);

  useEffect(() => {
    let unsubscribeLatestPost: () => void;
    (async () => {
      try {
        unsubscribeLatestPost =
          await props.tradingStore.subscribeToLatestPosts();
      } catch (error) {
        console.error(error);
      }
    })();
    const disposeAutorun = autorun(() => {
      const latestPosts = props.tradingStore.latestPosts;

      if (latestPosts) {
        setPostsBuy(
          latestPosts.filter((f) => f.post_type === "BUY") as IVWPost[],
        );
        setPostsSell(
          latestPosts.filter((f) => f.post_type === "SELL") as IVWPost[],
        );
      }
    });

    return () => {
      disposeAutorun();
      try {
        if (unsubscribeLatestPost) unsubscribeLatestPost();
      } catch (error) {
        console.error(error);
      }
    };
  }, [props.tradingStore]);

  return (
    <Container>
      <Stack direction="column" alignItems="center">
        <Typography variant="h1" mt="86px" mb="26px">
          Buy and Sell your digital assets securely <br /> and privately on HAP
          Chain
        </Typography>
        <SvgIcon
          component={HeroSectionPic}
          sx={{
            height: "50.73529411764706%",
            width: "auto",
          }}
          inheritViewBox
        />
        <Box mb="117.5px" width="100%">
          <Typography
            component="h2"
            variant="h3"
            sx={{
              mt: "32.5px",
              mb: "54.5px",
            }}
          >
            Buy assets on hap chain
          </Typography>
          <Paper sx={{ pt: "62.5px", pb: "48px", px: "67.5px" }}>
            <HomeTable key={"sell"} tradeList={postsSell} isBuy rowsCount={4} />
          </Paper>
          <Typography
            component="h2"
            variant="h3"
            sx={{
              mt: "72.5px",
              mb: "30px",
            }}
          >
            Sell assets on hap chain
          </Typography>
          <Paper sx={{ pt: "62.5px", pb: "48px", px: "67.5px" }}>
            <HomeTable key={"buy"} tradeList={postsBuy} rowsCount={4} />
          </Paper>
        </Box>
      </Stack>
    </Container>
  );
};

export default HomePage;
